"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserWall = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const toolbox_1 = require("@streem/toolbox");
const first_from_group_1 = require("../../util/rx/first_from_group");
const wall_1 = require("./wall");
const sort_client_created_at_1 = require("../../util/rx/sort_client_created_at");
const utils_1 = require("./utils");
const logger_1 = require("../../util/logger");
const repeating_task_1 = require("../../util/repeating_task");
let heartbeatCount = 0;
class UserWall extends wall_1.Wall {
    constructor(config) {
        super(config);
        this.unsubscribe = new rxjs_1.Subject();
        this.currentInviteSubject = new rxjs_1.BehaviorSubject(undefined);
        this.currentPendingInvite = this.currentInviteSubject.asObservable();
        logger_1.logger.info('Creating UserWall...');
        this.userDeviceUpdates = this.itemsByType.pipe((0, utils_1.findInGroup)('lastIdentifiedDevice'), (0, utils_1.accumulateAndMapWallEvents)('lastIdentifiedDevice'), (0, sort_client_created_at_1.sortClientCreatedAt)(), (0, operators_1.shareReplay)(1));
        this.smsDeliveryStatuses = this.itemsByType.pipe((0, utils_1.findInGroup)('smsDeliveryStatus'), (0, utils_1.accumulateAndMapWallEvents)('smsDeliveryStatus'), (0, sort_client_created_at_1.sortClientCreatedAt)(), (0, operators_1.shareReplay)(1));
        this.userAvailabilityStatus = this.itemsByType.pipe((0, utils_1.findInGroup)('userAvailability'), (0, utils_1.accumulateAndMapWallEvents)('userAvailability'), (0, sort_client_created_at_1.sortClientCreatedAt)(), (0, first_from_group_1.firstFromGroup)(), (0, operators_1.shareReplay)(1));
        this.groupReservations = this.itemsByType.pipe((0, utils_1.findInGroup)('lastGroupReservation'), (0, utils_1.accumulateAndMapWallEvents)('lastGroupReservation'), (0, sort_client_created_at_1.sortClientCreatedAt)(), (0, first_from_group_1.firstFromGroup)(), (0, operators_1.shareReplay)(1));
        /**
         * Listen for current pending invites
         * and publish the current pending invite when it's found
         */
        this.getCurrentPendingInvites(this.getAllRoomInvitations())
            .pipe((0, first_from_group_1.firstFromGroup)(), (0, operators_1.takeUntil)(this.unsubscribe))
            .subscribe((nextInvite) => {
            var _a;
            if ((nextInvite === null || nextInvite === void 0 ? void 0 : nextInvite.id) !== ((_a = this.currentInviteSubject.value) === null || _a === void 0 ? void 0 : _a.id)) {
                logger_1.logger.info(`UserWall received invitation invitationId: ${nextInvite === null || nextInvite === void 0 ? void 0 : nextInvite.id} with status: ${nextInvite === null || nextInvite === void 0 ? void 0 : nextInvite.status}`, nextInvite);
                this.currentInviteSubject.next(nextInvite);
            }
        });
        // Heartbeat task to ensure Twilio Sync connection is alive
        this.heartBeatTask = new repeating_task_1.RepeatingTask({
            taskName: UserWall.HEART_BEAT_TASK_NAME,
            intervalMs: UserWall.HEART_BEAT_INTERVAL_MS,
            errorThreshold: UserWall.HEART_BEAT_ERROR_THRESHOLD,
            task: () => {
                var _a;
                const connectionState = this.wallSyncClient.wallSyncConnectionState;
                if (this.tokenExpired === true) {
                    logger_1.logger.warn(`UserWall not sending heartbeat due to expired SyncClient token`);
                }
                else if (connectionState !== 'connected') {
                    logger_1.logger.warn(`UserWall skipping the sending of heartbeat because SyncClient is not in 'connected' state; current connectionState=${connectionState}`);
                }
                else {
                    const currentTime = new Date();
                    const heartbeatWallItem = new streem_sdk_protobuf_1.streem.user.UserWallItem({
                        id: `heartbeat`,
                        ownerDeviceId: this.config.localDeviceId.toString(),
                        heartbeat: {
                            timestamp: this.getProtobufTimestamp(currentTime),
                            count: ++heartbeatCount,
                        },
                    });
                    logger_1.logger.debug(`UserWall Sending Wall Heartbeat... wallItemId=${heartbeatWallItem.id} count=${(_a = heartbeatWallItem.heartbeat) === null || _a === void 0 ? void 0 : _a.count}`);
                    this.addOrUpdate(heartbeatWallItem);
                }
            },
            onError: err => logger_1.logger.error(`taskName=${UserWall.HEART_BEAT_TASK_NAME} userId=${config.localUserId} encountered error=${err}`),
        });
    }
    connect() {
        const _super = Object.create(null, {
            connect: { get: () => super.connect }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            logger_1.logger.info(`UserWall connecting...`);
            yield _super.connect.call(this);
            logger_1.logger.info('Starting UserWall heartbeat task...');
            yield ((_a = this.heartBeatTask) === null || _a === void 0 ? void 0 : _a.start());
        });
    }
    disconnect() {
        const _super = Object.create(null, {
            disconnect: { get: () => super.disconnect }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            logger_1.logger.info('stopping UserWall heartbeat task... HEART_BEAT_INTERVAL_MS=$HEART_BEAT_INTERVAL_MS');
            this.heartBeatTask.stop();
            this.unsubscribe.next(undefined);
            logger_1.logger.info(`UserWall disconnecting...`);
            (_a = this.connectedSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            yield _super.disconnect.call(this);
        });
    }
    /**
     * Finds all room invitations on the user wall and sorts them from newest to oldest
     */
    getAllRoomInvitations() {
        return this.itemsByType.pipe((0, utils_1.findInGroup)('roomInvitation'), (0, utils_1.accumulateAndMapWallEvents)('roomInvitation'), (0, sort_client_created_at_1.sortClientCreatedAt)(), (0, operators_1.shareReplay)(1));
    }
    /**
     * Returns an observable of room invitations that are pending and not expired
     * @param invites Invites from the UserWall
     */
    getCurrentPendingInvites(invites) {
        return invites.pipe((0, operators_1.map)(invites => invites.filter(i => {
            var _a, _b;
            // No date? Get out of here
            if (!i.clientCreatedAt)
                return false;
            // Not pending? Get out of here
            if (i.status !== streem_sdk_protobuf_1.streem.api.RoomInvitation.Status.STATUS_PENDING)
                return false;
            (0, toolbox_1.invariant)((_b = (_a = i === null || i === void 0 ? void 0 : i.clientCreatedAt) === null || _a === void 0 ? void 0 : _a.seconds) === null || _b === void 0 ? void 0 : _b.low, 'Invite clientCreatedAt missing "seconds" property');
            // Is the invite older than 48 hours (in seconds)?
            const FORTY_EIGHT_HOURS = 60 * 60 * 48;
            const inviteIsExpired = new streem_sdk_protobuf_1.Long(new Date().getTime() / 1000)
                .sub(i.clientCreatedAt.seconds)
                .greaterThan(FORTY_EIGHT_HOURS);
            return !inviteIsExpired;
        })));
    }
    getProtobufTimestamp(date) {
        const millis = date.getTime();
        return new streem_sdk_protobuf_1.Timestamp({
            seconds: new streem_sdk_protobuf_1.Long(millis / 1000),
            nanos: (millis % 1000) * 1e6,
        });
    }
}
exports.UserWall = UserWall;
UserWall.HEART_BEAT_TASK_NAME = 'UserWall_HeartbeatTask';
UserWall.HEART_BEAT_INTERVAL_MS = 1000 * 30 * 1; // 30 seconds
UserWall.HEART_BEAT_ERROR_THRESHOLD = 30;
//# sourceMappingURL=user_wall.js.map